import { render, staticRenderFns } from "./comp_dpc-Hotspot.vue?vue&type=template&id=04fa944a&scoped=true&"
import script from "./comp_dpc-Hotspot.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-Hotspot.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-Hotspot.vue?vue&type=style&index=0&id=04fa944a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa944a",
  null
  
)

export default component.exports